export default __webpack_public_path__ + "static/media/ICONO_PLANES.738b9138.svg";